<app-accordion [elementId]="subSubGroup.id"
               [prefixId]=" prefixId"
               [isDeletable]="subSubGroup.deletable"
               [elementLabel]="subSubGroup._label"
               [isRepeatable]="subSubGroup._repeatable"
               [infoBulle]="subSubGroup.infoBulle"
               [groupType]="getGroupType(subSubGroup.id)"
               (addSomething)="addSubSubGroup()"
               (deleteSomething)="removeSubSubGroup()">
<p class="messageInfo">
  {{parcoursUtilisateur(subSubGroup)}}
                             </p>
  <div *ngFor="let field of subSubGroup.fields; let i = index">
    <app-form-input [prefixId]="prefixId" [parentForm]="formGroup"
                    [field]="field" [subSectionId]="subSectionId"
                    [repeatablePath]="repeatablePath" [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
                    [getRepeatablePathWithIndexForInput]="getRepeatablePathWithIndexForInput"
                    [noticeValue]="noticeValue" [groupOrSectionId]="subSubGroup.id" (newField)="newField($event)"
                    (deleteField)="deleteField($event)" [index]="index">

    </app-form-input>
  </div>
  <div *ngFor="let subSubSubGroup of subSubGroup.subSubSubGroup; let i = index">
    <app-sub-sub-sub-group
      [hidden]="subSubSubGroup?.hidden"
      *ngIf="!subSubSubGroup?.hidden"
      [prefixId]="prefixId" [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
      [formGroup]="formGroup"
      [subSubSubGroup]="subSubSubGroup"
      (newSubSubSubGroup)="newSubSubSubGroup($event)"
      (deleteSubSubSubGroup)="deleteSubSubSubGroup($event)"
      [repeatablePath]="repeatablePath" [subSectionId]="subSectionId"
      [repeatablePathWithIndex]="getRepeatablePathWithIndexForSubSubSubGroup(subSubSubGroup)"
      [noticeValue]="noticeValue" [linkForRouter]="linkForRouter" [index]="index">
    </app-sub-sub-sub-group>
  </div>
</app-accordion>
